import {
  DefaultTrackPromotionEvent,
  trackG4ViewPromotion,
} from '@/common/analytics/gtm/shared/trackViewPromotion';
import { ImpressionsContextProvider } from '@/common/impressions';

import CATEGORIES_DATA from './Category.data';
import styles from './category.module.scss';
import CategoryItem from './CategoryItem';

const Categories = () => {
  return (
    <ImpressionsContextProvider<DefaultTrackPromotionEvent>
      callback={(data) => {
        trackG4ViewPromotion(data);
      }}
      shouldSendSeparately
    >
      <section className={styles.container} data-testid="categories">
        <h2 className={styles.heading}>Still looking for a match?</h2>
        <div className={styles.slider}>
          <ul className={styles.grid}>
            {CATEGORIES_DATA.map((category, index) => (
              <CategoryItem category={category} index={index} key={category.url} />
            ))}
          </ul>
        </div>
      </section>
    </ImpressionsContextProvider>
  );
};

export default Categories;
